import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import util from '../../common/util';

@Component
export default class HeaderComponent extends Vue {

    userInfo() {
        this.$router.push({
            path:'/userInfo',
        });
    }

    //退出登录
    logOut() {
        this.axios.post('/api/PersonalCenter/logout').then((data) => {            
            switch (data.status) {
                case 200:
                    if (data.headers.location) {
                        window.location.href = data.headers.location;
                    } else {
                        window.location.reload();
                    }
                    break;
            }
        });      
    }

    mounted() {
    }
}
